module.exports = __webpack_public_path__ + "images/mangoe05c3c0faa1aaf2f7f40aeb93195b153.png";